import _typeof from './../../external_lib/@babel/runtime/helpers/esm/typeof.js';
var isFF = (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' && /Firefox/i.test(navigator.userAgent);
export { isFF as default };
//# sourceMappingURL=isFirefox.js.map
